import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  getTypeOfFrequencyBarChart,
  getTypeOfFrequencyPieChart
} from 'store/scenes/graphicalStatistics/settingsPane/selectors';
import {
  getActiveChartsAndGraphsTab
} from 'store/scenes/graphicalStatistics/rightPane/selectors';

import { FREQUENCY } from '../SettingsForm/AdditionalFields/Component';

import BottomPane from './Component';

const BottomPaneContainer = props => {
  return (
    props.activeChartsAndGraphsTab === 6
      ? null
      : <BottomPane {...props} />
  );
};

BottomPaneContainer.propTypes = {
  isTypeOfGraphsFrequencyBarChart: PropTypes.bool.isRequired,
  activeChartsAndGraphsTab: PropTypes.number
};

const mapStateToProps = state => ({
  isTypeOfGraphsFrequencyBarChart: getTypeOfFrequencyBarChart(state) === FREQUENCY,
  isTypeOfGraphsFrequencyPieChart: getTypeOfFrequencyPieChart(state) === FREQUENCY,
  activeChartsAndGraphsTab: getActiveChartsAndGraphsTab(state)
});


export default connect(mapStateToProps, null)(BottomPaneContainer);
